export const isPricingName = (str = '') =>
	['Price', 'Starting Price', 'Starting Price Range', 'Price Range'].includes(
		str,
	);
